/**
 * @module common/components/form/modal_form_buttons
 */
import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';

/**
 * Reusable modal form buttons that can switch between the form steps
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class ModalFormButtons extends Component {
  constructor(props) {
    super(props);

    this.onChangeStep = this.onChangeStep.bind(this);
  }

  onChangeStep(event) {
    event.preventDefault();
    event.persist();

    const { manualAction, changeStep, currentStep, formSteps,
      changeStepCondition } = this.props;

    // Sometimes we want to handle step changes manually
    if (manualAction) {
      manualAction();
      return;
    }

    const stepIndex = formSteps.indexOf(currentStep);
    let nextStep = formSteps[stepIndex + 1];

    if (changeStepCondition) {
      nextStep = changeStepCondition();
    }

    changeStep(nextStep);
  }

  render() {
    const { nextActive, currentStep } = this.props;
    const nextButtonName = `modal_form_${currentStep}`;
    const cancelButtonName = `modal_form_cancel_${currentStep}`;

    // hack for redux-form
    const styles = {
      display: 'none',
    }

    return (
      <div className="form-button-block">
        <button type="submit" style={styles} />
        <button
          className={classNames('btn btn-primary submit', {
            disabled: !nextActive })}
          type="button"
          disabled={!nextActive}
          name={nextButtonName}
          onClick={this.onChangeStep}
        >Next</button>
        <button
          className="btn btn-text cancel"
          type="button"
          name={cancelButtonName}
          onClick={this.props.onToggleDialog}
        >Cancel</button>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {string} currentStep - current form step
 * @property {bool} nextActive - boolean value defining if next step button is active
 * @property {array} formSteps - list of all of the form steps
 * @property {func} manualAction - *optional function to override the built-in step change action
 * @property {func} changeStep - function to be called when step changes
 * @property {func} changeStepCondition - *optional function checking conditions before switching steps
 * @property {func} onToggleDialog - function to be called when form close button is clicked
 */
ModalFormButtons.propTypes = {
  currentStep: PropTypes.string,
  nextActive: PropTypes.bool,
  formSteps: PropTypes.array,
  manualAction: React.PropTypes.oneOfType([
    React.PropTypes.func,
    React.PropTypes.bool
  ]),
  changeStep: PropTypes.func,
  changeStepCondition: PropTypes.func,
  onToggleDialog: PropTypes.func,
};



// WEBPACK FOOTER //
// ./common/components/form/modal_form_buttons.jsx